import React, { useCallback } from 'react';
import { getReverseGeocode } from '../../util/api';
import { extractFromResponse } from '../../util/dataExtractor';
import css from './ShippingAddressPanel.module.css';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import { LocationAutocompleteInput } from '..';
import { Field, FormSpy } from 'react-final-form';
import { debounce } from 'lodash';
const ShippingAddressPanel = ({ form, intl, identity, name, label }) => {
  const { values } = form.getState();
  const { location, shouldFetchReverseGeoCode, newShippingLocation } = values || {};
  const { lat, lng } = location?.selectedPlace?.origin
    ? location?.selectedPlace?.origin
    : newShippingLocation?.selectedPlace?.origin || {};
  const debouncedFetchGeoCode = useCallback(
    debounce(async (latitude, longitude) => {
      const response = await getReverseGeocode({ latitude, longitude });
      const state = extractFromResponse(response, 'region', 'name');
      const postcode = extractFromResponse(response, 'postcode', 'name');
      const city = extractFromResponse(response, 'place', 'name');
      const street = extractFromResponse(response, 'street', 'name');
      if (city || state || postcode) {
        form.batch(() => {
          form.change('state', state);
          form.change('zipCode', postcode);
          form.change('city', city);
          form.change('addressLine2', street);
        });
      }
    }, 300),
    [form]
  );
  return (
    <div className={css.newLocationForm}>
      <div className={css.field}>
        <label htmlFor="addressLine2">{label}</label>
        <FormSpy subscription={{ values: { location: true } }}>
          {({ values }) => {
            if (lat && lng && shouldFetchReverseGeoCode) {
              debouncedFetchGeoCode(lat, lng);
            }
            return null;
          }}
        </FormSpy>
        <Field
          className={css.formFld}
          name={name}
          format={identity}
          render={({ input, meta }) => {
            const { onChange, ...restInput } = input;
            form.change('shouldFetchReverseGeoCode', false);
            const searchOnChange = value => {
              onChange(value);
              form.change('shouldFetchReverseGeoCode', !!value);
            };

            const searchInput = { ...restInput, onChange: searchOnChange };
            return (
              <LocationAutocompleteInput
                placeholder={intl.formatMessage({
                  id: 'EditListingLocationForm.locationPlaceholder',
                })}
                iconClassName={css.searchInputIcon}
                inputClassName={css.searchInput}
                className={css.addressFld}
                predictionsClassName={css.searchPredictions}
                input={searchInput}
                meta={meta}
              />
            );
          }}
        />
        {/*
        <FieldTextInput
          className={css.addressFld}
          type="text"
          id="addressLine2"
          name="addressLine2"
          placeholder="Address line 2"
        /> */}
        <div className={css.formRow}>
          <div className={css.formFld}>
            <FieldTextInput
              className={css.addressFld}
              type="text"
              id="City"
              name="city"
              placeholder="City"
            />
          </div>
          <div className={css.formFld}>
            <div className={css.formRow}>
              <div className={css.formFld}>
                <FieldTextInput
                  className={css.addressFld}
                  type="text"
                  id="state"
                  name="state"
                  placeholder="State"
                />
              </div>
              <div className={css.formFld}>
                <FieldTextInput
                  className={css.addressFld}
                  type="text"
                  id="zipCode"
                  name="zipCode"
                  placeholder="Zip code"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingAddressPanel;
